import { EXTERNAL_URL } from "@hl/shared-features/lib/config";

import { Collection } from "../../../apollo/graphql.generated";
import { getMintPageUrl } from "../../../config";

export function reportCollectionMailtoUri({
  id,
  name,
}: Pick<Collection, "id" | "name">) {
  const body = `Collection url: ${getMintPageUrl(id)}
Reason for reporting:

Additional information:

`.replace(/$/m, "\n");

  const email = {
    subject: `Report collection ${name}`,
    body,
  };
  const params = Object.entries(email)
    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
    .join("&");

  return `mailto:${EXTERNAL_URL.HL_EMAIL}?${params}`;
}
